/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExercisePrerequisiteDTO } from './ExercisePrerequisiteDTO';
import {
    ExercisePrerequisiteDTOFromJSON,
    ExercisePrerequisiteDTOFromJSONTyped,
    ExercisePrerequisiteDTOToJSON,
    ExercisePrerequisiteDTOToJSONTyped,
} from './ExercisePrerequisiteDTO';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';
import type { ExerciseConfig } from './ExerciseConfig';
import {
    ExerciseConfigFromJSON,
    ExerciseConfigFromJSONTyped,
    ExerciseConfigToJSON,
    ExerciseConfigToJSONTyped,
} from './ExerciseConfig';
import type { EquipmentConfig } from './EquipmentConfig';
import {
    EquipmentConfigFromJSON,
    EquipmentConfigFromJSONTyped,
    EquipmentConfigToJSON,
    EquipmentConfigToJSONTyped,
} from './EquipmentConfig';
import type { MuscleIntensity } from './MuscleIntensity';
import {
    MuscleIntensityFromJSON,
    MuscleIntensityFromJSONTyped,
    MuscleIntensityToJSON,
    MuscleIntensityToJSONTyped,
} from './MuscleIntensity';
import type { SupportExerciseDTO } from './SupportExerciseDTO';
import {
    SupportExerciseDTOFromJSON,
    SupportExerciseDTOFromJSONTyped,
    SupportExerciseDTOToJSON,
    SupportExerciseDTOToJSONTyped,
} from './SupportExerciseDTO';

/**
 * 
 * @export
 * @interface CreateExerciseDTO
 */
export interface CreateExerciseDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateExerciseDTO
     */
    difficulty?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseDTO
     */
    imageId?: string;
    /**
     * 
     * @type {ExerciseConfig}
     * @memberof CreateExerciseDTO
     */
    config: ExerciseConfig;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseDTO
     */
    videoId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseDTO
     */
    youtubeVideoId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExerciseDTO
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {Array<MuscleIntensity>}
     * @memberof CreateExerciseDTO
     */
    muscleIntensities: Array<MuscleIntensity>;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof CreateExerciseDTO
     */
    links: Array<HTTPLink>;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseDTO
     */
    mainBodyZoneId: string;
    /**
     * 
     * @type {Array<EquipmentConfig>}
     * @memberof CreateExerciseDTO
     */
    equipment: Array<EquipmentConfig>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExerciseDTO
     */
    additionalImageIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateExerciseDTO
     */
    publiclyVisible?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExerciseDTO
     */
    progressionExerciseIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExerciseDTO
     */
    regressionExerciseIds: Array<string>;
    /**
     * 
     * @type {Array<SupportExerciseDTO>}
     * @memberof CreateExerciseDTO
     */
    supportExercises: Array<SupportExerciseDTO>;
    /**
     * 
     * @type {Array<ExercisePrerequisiteDTO>}
     * @memberof CreateExerciseDTO
     */
    prerequisites: Array<ExercisePrerequisiteDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExerciseDTO
     */
    exerciseFactIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExerciseDTO
     */
    synonyms?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateExerciseDTO
     */
    isUniLateral?: boolean;
}

/**
 * Check if a given object implements the CreateExerciseDTO interface.
 */
export function instanceOfCreateExerciseDTO(value: object): value is CreateExerciseDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('categoryIds' in value) || value['categoryIds'] === undefined) return false;
    if (!('muscleIntensities' in value) || value['muscleIntensities'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('mainBodyZoneId' in value) || value['mainBodyZoneId'] === undefined) return false;
    if (!('equipment' in value) || value['equipment'] === undefined) return false;
    if (!('progressionExerciseIds' in value) || value['progressionExerciseIds'] === undefined) return false;
    if (!('regressionExerciseIds' in value) || value['regressionExerciseIds'] === undefined) return false;
    if (!('supportExercises' in value) || value['supportExercises'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    return true;
}

export function CreateExerciseDTOFromJSON(json: any): CreateExerciseDTO {
    return CreateExerciseDTOFromJSONTyped(json, false);
}

export function CreateExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'difficulty': json['difficulty'] == null ? undefined : json['difficulty'],
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'config': ExerciseConfigFromJSON(json['config']),
        'videoId': json['videoId'] == null ? undefined : json['videoId'],
        'youtubeVideoId': json['youtubeVideoId'] == null ? undefined : json['youtubeVideoId'],
        'categoryIds': json['categoryIds'],
        'muscleIntensities': ((json['muscleIntensities'] as Array<any>).map(MuscleIntensityFromJSON)),
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
        'mainBodyZoneId': json['mainBodyZoneId'],
        'equipment': ((json['equipment'] as Array<any>).map(EquipmentConfigFromJSON)),
        'additionalImageIds': json['additionalImageIds'] == null ? undefined : json['additionalImageIds'],
        'publiclyVisible': json['publiclyVisible'] == null ? undefined : json['publiclyVisible'],
        'progressionExerciseIds': json['progressionExerciseIds'],
        'regressionExerciseIds': json['regressionExerciseIds'],
        'supportExercises': ((json['supportExercises'] as Array<any>).map(SupportExerciseDTOFromJSON)),
        'prerequisites': ((json['prerequisites'] as Array<any>).map(ExercisePrerequisiteDTOFromJSON)),
        'exerciseFactIds': json['exerciseFactIds'] == null ? undefined : json['exerciseFactIds'],
        'synonyms': json['synonyms'] == null ? undefined : json['synonyms'],
        'isUniLateral': json['isUniLateral'] == null ? undefined : json['isUniLateral'],
    };
}

export function CreateExerciseDTOToJSON(json: any): CreateExerciseDTO {
    return CreateExerciseDTOToJSONTyped(json, false);
}

export function CreateExerciseDTOToJSONTyped(value?: CreateExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'difficulty': value['difficulty'],
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'config': ExerciseConfigToJSON(value['config']),
        'videoId': value['videoId'],
        'youtubeVideoId': value['youtubeVideoId'],
        'categoryIds': value['categoryIds'],
        'muscleIntensities': ((value['muscleIntensities'] as Array<any>).map(MuscleIntensityToJSON)),
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
        'mainBodyZoneId': value['mainBodyZoneId'],
        'equipment': ((value['equipment'] as Array<any>).map(EquipmentConfigToJSON)),
        'additionalImageIds': value['additionalImageIds'],
        'publiclyVisible': value['publiclyVisible'],
        'progressionExerciseIds': value['progressionExerciseIds'],
        'regressionExerciseIds': value['regressionExerciseIds'],
        'supportExercises': ((value['supportExercises'] as Array<any>).map(SupportExerciseDTOToJSON)),
        'prerequisites': ((value['prerequisites'] as Array<any>).map(ExercisePrerequisiteDTOToJSON)),
        'exerciseFactIds': value['exerciseFactIds'],
        'synonyms': value['synonyms'],
        'isUniLateral': value['isUniLateral'],
    };
}

